// @core/stores/secret/SecretDatabaseSecretStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { secretApi } from '@core/api';
import type {
  CreateDatabaseRoleRequest,
  DatabaseRoleResponse,
  GenerateCredentialsRequest,
  GenerateCredentialsResponse,
  ListDatabaseRolesResponse,
} from '@core/types/secret';

class SecretDatabaseSecretStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Create database role
   */
  async CreateDatabaseRole(engine_id: string, data: CreateDatabaseRoleRequest): Promise<DatabaseRoleResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.CreateDatabaseRole(engine_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Delete database role
   */
  async DeleteDatabaseRole(engine_id: string, role_name: string): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.DeleteDatabaseRole(engine_id, role_name);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Generate database credentials
   */
  async GenerateCredentials(engine_id: string, role_name: string, data: GenerateCredentialsRequest): Promise<GenerateCredentialsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.GenerateCredentials(engine_id, role_name, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get database role
   */
  async GetDatabaseRole(engine_id: string, role_name: string): Promise<DatabaseRoleResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.GetDatabaseRole(engine_id, role_name);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List database roles
   */
  async ListDatabaseRoles(engine_id: string, params?: { limit?: string | number | boolean; cursor?: string | number | boolean; direction?: string | number | boolean; sort?: string | number | boolean; }): Promise<ListDatabaseRolesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.ListDatabaseRoles(engine_id, params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const secretDatabaseSecretStore = new SecretDatabaseSecretStore();
